$(document).ready(function() {
  // Lets hide the tabs on load
  $(".tab-content").show();
  // Uncomment to show the first tab on load
  // $("p").first().show();

  // Our function to show and hide on click
  $(".tab").click(function()
  {
    $(this).next(".tab-content").slideToggle(250);
    $(this).siblings().next(".tab-content").slideUp(100);
    // Toggle the open class for our svg icon
    $(this).find('.icon').toggleClass('open')
  });
});